<!-- TM-1000002003: Kommentare-Fixture (recording B) — isolated sandbox for mvs-object-comments on
     xx.XxCarPilotBrandComment. This page was stripped down to just this fixture; the module-convention
     wrapper (xx-test-component p-3, see xx-form-logic.component.html / xx-form-external-save-test.page.html)
     gives it the same page-level padding as the other xx pages. -->
@if (initialized) {
    <div class="xx-test-component p-3">
        <h3>Kommentare-Fixture (XxCarPilotBrand)</h3>

        <!-- TM-1000002003: framework CRUD read (MvsCrudService via the registry), no search index. -->
        <p-select
                [options]="carPilotBrands"
                [ngModel]="selectedCarPilotBrand"
                (ngModelChange)="onCarPilotBrandSelect($event)"
                optionLabel="name"
                placeholder="Marke auswählen"
        ></p-select>

        @if (carPilotBrandIdentifier) {
            <div class="mt-3 surface-0 border-round-lg p-3">
                <mvs-object-comments
                        [mainObject]="carPilotBrandIdentifier"
                        linkedEntityObjectType="xx.XxCarPilotBrandComment"
                        headline="Kommentare"
                        [useSimpleEditor]="true">
                </mvs-object-comments>
            </div>
        } @else {
            <p class="text-color-secondary mt-3">Bitte zuerst eine Marke auswählen.</p>
        }
    </div>
}
